export const leggTilEnDag = (dato: Date): Date => {
  // datoer som kommer inn her er alltid i lokal tid midnatt
  const datoPlussEnDag = new Date(dato);
  datoPlussEnDag.setDate(datoPlussEnDag.getDate() + 1);
  return datoPlussEnDag;
};
